import React from "react";
import "./index.less";
import { Cascader, ConfigProvider, DatePicker, Form, Input } from "antd";
import { FormItem } from "@/types/base";


interface FormItemsProps {
  // Define your props here
  formItems?: FormItem[];
  isChange:boolean;
}

const prefix = "FormItems";
const FormItems = (props: FormItemsProps) => {
  const { formItems } = props;
  return (
    <>
      {formItems?.map((item: FormItem, index) => {
        return (
          <Form.Item label={item.label} name={item.name} key={index} required={item.required} rules={item.rules}>

            {item.itemType === "input" && <Input

              type={item?.type || "text"}
              defaultValue={item.defaultValue}
              disabled={item.disabled}
              placeholder={item.placeholder}
              maxLength={item.maxLength}
            />}
            {item.itemType === "select" && (
              <Cascader
                className={""}
                style={item?.style}
                popupClassName={"questions-category-cascader common-select-popup"}
                options={item.options}
                placeholder={item.placeholder}
              />
              
            )}
            {
              item.itemType === "datePicker" &&
              (
                <DatePicker
                  popupClassName='common-range-picker'
                  disabledDate={item.disabledDate}
                />)
            }
          </Form.Item>
        );
      })}
    </>
  );
};

export default React.memo(FormItems);
